
export default class BankAccountCreationRequest {

    static toJson = function (item) {
        let jsonObj = {};
        jsonObj["title"] = item.title;
        jsonObj["ethnicity"] = item.ethnicity;
        jsonObj["id-issue-date"] = item.idIssueDate;
        jsonObj["unit"] = item.unit;
        jsonObj["complex-name"] = item.complexName;
        jsonObj["source-of-funds"] = item.sourceOfFunds;
        jsonObj["street-number"] = item.streetNumber;
        jsonObj["documents"] = item.documents;
        jsonObj["email"] = item.email;
        return jsonObj;
    };

}
